import {
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  FaAssistiveListeningSystems,
  FaCar,
  FaQuestion,
  FaWrench,
} from "react-icons/fa";
import ArrowIcon from "../common/icons/ArrowIcon";

/**
 * Renders the chat suggestion menu
 * 
 * @param {Object} props - The props of the component
 * @returns The chat suggestion menu
 */
const ChatSuggestionsMenu = ({ onSelectSuggestion, width }) => {
  const { t } = useTranslation();
  const choices = useMemo(
    () => [
      {
        title: t("plugin.chat.video.title"),
        icon: <FaAssistiveListeningSystems />,
        content: t("plugin.chat.video.content"),
      },
      {
        title: t("plugin.chat.help.title"),
        icon: <FaQuestion />,
        content: t("plugin.chat.help.content"),
      },
      {
        title: t("plugin.chat.towing.title"),
        icon: <FaWrench />,
        content: t("plugin.chat.towing.content"),
      },
      {
        title: t("plugin.chat.taxi.title"),
        icon: <FaCar />,
        content: t("plugin.chat.taxi.content"),
      },
    ],
    [t],
  );

  return (
    <Menu placement={"top-start"}>
      {({ isOpen }) => (
        <React.Fragment>
          <MenuButton
            as={IconButton}
            borderRadius={"full"}
            backgroundColor={"#F1F1F177"}
            color={"white"}
            isActive={isOpen}
            icon={
              <Icon
              transition={"linear .2s"}
                as={ArrowIcon}
                transform={isOpen ? "scale(1, -1)" : ""} />
            }
            size={"md"}
            borderWidth={"1px"}
            borderColor={"#F1F1F177"}
            _hover={{ backgroundColor: "#5B5F6177" }}
            _active={{ backgroundColor: "#5B5F6177" }}
          />
          <MenuList width={width}>
            {choices.map((choice) => (
              <MenuItem
                color={"black"}
                onClick={() => onSelectSuggestion(choice.content)}
              >
                {choice.title}
              </MenuItem>
            ))}
          </MenuList>
        </React.Fragment>
      )}
    </Menu>
  );
};

export default React.memo(ChatSuggestionsMenu);
